import { Attendance, FreeEntryPoint } from '../interfaces/attendance';
import { AttendanceEventType } from '../interfaces/attendance-list-history.interface';

export type FepState = 'open' | 'ending' | 'closed';

export const FEP_ENDING_THRESHOLD_MS = 12 * 60 * 60 * 1000;

export const FEP_EVENT_TYPES = [
  AttendanceEventType.ACTION_FREE_ENTRY_POINT_STARTED,
  AttendanceEventType.ACTION_FREE_ENTRY_POINT_ARCHIVED,
  AttendanceEventType.ACTION_FREE_ENTRY_POINT_REMAINING,
];

export function isFepEventType(type?: string | null): boolean {
  return FEP_EVENT_TYPES.includes(type as AttendanceEventType);
}

export function isFepFreeMessage(stats?: Attendance['stats'] | null): boolean {
  return !!stats?.freeEntryPoint?.active || !!stats?.freeEntryPointPending;
}

export function getFepState(
  freeEntryPoint?: Pick<FreeEntryPoint, 'expiresAt'> | null,
  now: number = Date.now()
): FepState | null {
  if (!freeEntryPoint?.expiresAt) return null;

  const expiresAtMs = new Date(freeEntryPoint.expiresAt).getTime();
  if (Number.isNaN(expiresAtMs)) return null;

  const remainingMs = expiresAtMs - now;
  if (remainingMs <= 0) return 'closed';
  if (remainingMs <= FEP_ENDING_THRESHOLD_MS) return 'ending';
  return 'open';
}

export function formatFepCountdown(
  expiresAt: string,
  now: number = Date.now()
): string {
  const remainingMs = Math.max(0, new Date(expiresAt).getTime() - now);
  const totalMinutes = Math.floor(remainingMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}h${String(minutes).padStart(2, '0')}`;
}
